import { uniqBy } from "lodash";

export const getDropdownOptions = (option: string, existing: { text: string; value: string }[]) => {
  const trimmed = option?.trim();
  const initialOptions = existing ?? [];
  const options = trimmed ? [...initialOptions, { text: trimmed, value: trimmed }] : initialOptions;

  return uniqBy(options, "value");
};
